export enum FormType {
  Donation = 'donation',
  Petition = 'petition',
  Recruiting = 'recruiting',
}
